import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUserData } from '@/redux/modules/account/user/user.selectors';

import { ExternalRouteButton } from '../RouteButton/RouteButton';

const SuspendedBidderBannerComponent = () => {
    const { pathname } = useLocation();
    const { formatMessage } = useIntl();
    const biddingConsole = pathname.includes('/console/');
    const { creditCardValidated, hasEverRegisteredForAuction, standing } = useAppSelector(getUserData);
    const show = !biddingConsole && standing === 's' && (creditCardValidated || hasEverRegisteredForAuction);

    if (!show) {
        return null;
    }

    return (
        <div className="sticky top-0 z-[1000] flex bg-[#e3e3e3] p-sm">
            <div className="flex flex-[1_1_auto] items-center justify-center">
                <BodyPrimary className="mr-md">
                    <FormattedMessage id="suspendedBidderBanner.text" />
                </BodyPrimary>
                <ExternalRouteButton
                    className="mt-0"
                    target="_blank"
                    to="https://help.liveauctioneers.com/article/146-how-do-i-restore-my-suspended-account"
                >
                    {formatMessage({ id: 'suspendedBidderBanner.button' })}
                </ExternalRouteButton>
            </div>
        </div>
    );
};

export const SuspendedBidderBanner = SuspendedBidderBannerComponent;
